import TemplateQRModal from './TemplateQRModal';

export default TemplateQRModal;
